import React from 'react';
import { render, Fragment } from 'preact';

import { BaseComponent } from 'project/general';
import { EngagementFunctions } from 'shared/engagement-panel';
import { PledgeCard } from './pledge-card';
import { SharingComponent } from 'shared/engagement-panel';

export class PledgePageComponent extends BaseComponent {

    pledge = null;
    pledgeLikeFunctions = null;

    static getNamespace() {
        return 'pledge-page';
    }

    static getRequiredRefs() {
        return [
            'engagementModalPlaceholder',
            'pledgePlaceholder'
        ];
    }

    onInit() {
        this.pledge = this.options.pledge;
        this.engagementFunctions = new EngagementFunctions(
            this.options.engagementParameters
        );

        this.OnRenderPledge(this.pledge);
    }

    OnRenderPledge(pledge) {
        render(
            <Fragment>

                <div class="dw_pledge_single_page_section">
                    <PledgeCard
                        key={pledge.pledgeId}
                        pledge={pledge}
                        engagementFunctions={this.engagementFunctions}
                        engagementModalPlaceholder={this.refs.engagementModalPlaceholder}
                    />
                </div>

                <div class="dw_pledge_single_page_section">

                    <div
                        dangerouslySetInnerHTML={{
                            __html: this.options.engagementEncouragementText
                        }}>
                    </div>

                    <p>
                        <button
                            class="button button--primary"
                            onClick={this.onShareClick}>
                            Share this pledge
                        </button>
                    </p>

                    <p>
                        <button
                            class="button button--secondary"
                            onClick={this.onGoToPledgeWallClick}>
                            View all pledges
                        </button>
                    </p>
                </div>

            </Fragment>,
            this.refs.pledgePlaceholder
        );
    }

    onShareClick = () => {
        render(
            <SharingComponent
                shareUrl={this.pledge.pledgeUrl}
                engagementSettings={this.engagementFunctions.engagementSettings}
                onShareCloseClick={this.onShareCloseClick}
                onShared={this.onShared}>
            </SharingComponent>,
            this.refs.engagementModalPlaceholder
        );
    }

    onShareCloseClick = () => {
        this.refs.engagementModalPlaceholder.innerHTML = '';
    }

    onShared = () => {
        this.engagementFunctions.onShare(this.pledge.pledgeId);
    }

    onGoToPledgeWallClick = () => {
        if (
            this.options.pledgeWallPageUrl !== undefined &&
            this.options.pledgeWallPageUrl !== ''
        ) {
            window.location.href = this.options.pledgeWallPageUrl;
        }
    }

}

(function () {

    const run = () => {

        /*
         * Only initialise these enhancements on pledge-related pages.
         */
        const pledgePageSelectors = [
            '[data-component="pledge-page"]',
            '[data-namespace="pledge-page"]',
            '[data-dc-pledge-page]',
            '[data-dc-pledge-wall]',
            '.pledge-wall',
            '.dw_pledge_wall',
            '.dw_pledge_submission_section',
            '.dw_pledge_filter_bar',
            '.dw_pledge_single_page',
            '.dw_pledge_single_page_section',
            '#dw_pledge_submit'
        ];

        const currentPathSegments = window.location.pathname
            .toLowerCase()
            .split('/')
            .filter(Boolean);

        const isPledgePath = currentPathSegments.some(segment => {
            return segment === 'pledge-wall' || segment === 'pledge-page';
        });

        const hasPledgePageElement = pledgePageSelectors.some(selector => {
            return document.querySelector(selector) !== null;
        });

        if (!isPledgePath && !hasPledgePageElement) {
            return;
        }

        if (document.body.dataset.dwPledgeEnhancementsLoaded === 'true') {
            return;
        }

        document.body.dataset.dwPledgeEnhancementsLoaded = 'true';

        /*
         * Move to and focus the first-name field after progressing
         * to the relevant form step.
         */
        document.addEventListener('click', function (event) {
            const target = event.target;

            if (!(target instanceof Element)) {
                return;
            }

            const nextButton = target.closest('.form-next');

            if (!nextButton) {
                return;
            }

            setTimeout(function () {
                const input = document.querySelector(
                    "input[id^='form-DW_Pledge_Form-'][id$='_FirstName_Value']"
                );

                if (!input) {
                    console.warn('Input not found.');
                    return;
                }

                try {
                    input.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });

                    input.focus();
                } catch (error) {
                    console.error('Scroll/focus failed:', error);
                }
            }, 500);
        });

        /*
         * Add the correct poster to the campaign video once
         * the video has been rendered.
         */
        const injectPosterOnceReady = () => {
            const targetVideo = Array
                .from(document.querySelectorAll('video'))
                .find(video => {
                    const source = video.querySelector('source');

                    return (
                        source &&
                        source.src.includes(
                            '3_National_Autistic_Society_90_16x9'
                        )
                    );
                });

            if (!targetVideo) {
                return false;
            }

            targetVideo.setAttribute(
                'poster',
                'https://media.autism.org.uk/m/56bba790241fde11/original/pledge_wall_video_thumb.jpg'
            );

            return true;
        };

        let attempts = 0;
        const maxAttempts = Math.ceil(5000 / 300);

        const pollForVideo = setInterval(() => {
            attempts++;

            if (injectPosterOnceReady() || attempts >= maxAttempts) {
                clearInterval(pollForVideo);
            }
        }, 300);

        /*
         * Keep the modal directly under <body>. This prevents parent
         * stacking contexts from allowing page content to appear over it.
         */
        const ensurePledgeModalAtBodyLevel = () => {
            const modal = document.getElementById('dw_pledge_modal');

            if (!modal) {
                return null;
            }

            if (modal.parentElement !== document.body) {
                document.body.appendChild(modal);
            }

            return modal;
        };

        ensurePledgeModalAtBodyLevel();

        /*
         * Prevent duplicate sticky CTA wrappers.
         */
        if (document.getElementById('dw_pledge_sticky_button_wrapper')) {
            return;
        }

        const wrapper = document.createElement('div');

        wrapper.id = 'dw_pledge_sticky_button_wrapper';
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', 'Pledge actions');
        wrapper.setAttribute('aria-hidden', 'true');

        /*
         * Keep layout and visibility in SCSS so scrolling does not trigger
         * inline display changes or unnecessary browser repaints.
         */

        const pledgeButton = document.createElement('button');

        pledgeButton.id = 'dw_pledge_submit_sticky';
        pledgeButton.type = 'button';
        pledgeButton.className = 'button button--primary';
        pledgeButton.textContent = 'Make a pledge';
        pledgeButton.setAttribute('aria-label', 'Make your own pledge');
        pledgeButton.tabIndex = -1;

        const donateButton = document.createElement('button');

        donateButton.id = 'dw_pledge_donate_sticky';
        donateButton.type = 'button';
        donateButton.className = 'button button--secondary';
        donateButton.textContent = 'Donate';
        donateButton.setAttribute(
            'aria-label',
            'Donate to the Show Up appeal'
        );
        donateButton.tabIndex = -1;

        wrapper.appendChild(pledgeButton);
        wrapper.appendChild(donateButton);
        document.body.appendChild(wrapper);

        /*
         * The real pledge popup uses:
         * <div id="dw_pledge_modal" style="display: block;">
         */
        const isPledgeModalOpen = () => {
            const modal = ensurePledgeModalAtBodyLevel();

            if (!modal) {
                return false;
            }

            const style = window.getComputedStyle(modal);
            const opacity = parseFloat(style.opacity || '1');

            return (
                style.display !== 'none' &&
                style.visibility !== 'hidden' &&
                opacity > 0 &&
                modal.getAttribute('aria-hidden') !== 'true'
            );
        };

        let stickyButtonsVisible = false;

        const hideStickyButtons = () => {
            if (!stickyButtonsVisible) {
                return;
            }

            stickyButtonsVisible = false;

            wrapper.classList.remove('dw_show');
            wrapper.setAttribute('aria-hidden', 'true');

            pledgeButton.tabIndex = -1;
            donateButton.tabIndex = -1;
        };

        const showStickyButtons = () => {
            if (isPledgeModalOpen()) {
                hideStickyButtons();
                return;
            }

            if (stickyButtonsVisible) {
                return;
            }

            stickyButtonsVisible = true;

            wrapper.classList.add('dw_show');
            wrapper.setAttribute('aria-hidden', 'false');

            pledgeButton.tabIndex = 0;
            donateButton.tabIndex = 0;
        };

        const getCurrentScrollTop = () => {
            return (
                window.scrollY ||
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                0
            );
        };

        const getTriggerPoint = () => {
            const filterBar = document.querySelector(
                '.dw_pledge_filter_bar'
            );

            if (!filterBar) {
                return null;
            }

            return filterBar.offsetTop + filterBar.offsetHeight + 800;
        };

        const updateVisibility = () => {
            /*
             * Check the popup first. This is more important than the
             * current scroll position.
             */
            const modalOpen = isPledgeModalOpen();

            document.body.classList.toggle('modal-open', modalOpen);

            if (modalOpen) {
                hideStickyButtons();
                return;
            }

            const triggerPoint = getTriggerPoint();

            if (triggerPoint === null) {
                hideStickyButtons();
                return;
            }

            const scrollTop = getCurrentScrollTop();

            if (scrollTop > triggerPoint) {
                showStickyButtons();
            } else {
                hideStickyButtons();
            }
        };

        let visibilityFrame = null;

        const requestVisibilityUpdate = () => {
            if (visibilityFrame !== null) {
                return;
            }

            visibilityFrame = window.requestAnimationFrame(() => {
                visibilityFrame = null;
                updateVisibility();
            });
        };

        pledgeButton.addEventListener('click', function () {
            /*
             * Hide immediately, before the main button opens the popup.
             */
            hideStickyButtons();

            const mainButton = document.getElementById('dw_pledge_submit');

            if (mainButton) {
                mainButton.click();
            }

            requestVisibilityUpdate();
        });

        donateButton.addEventListener('click', function () {
            window.location.href =
                'https://www.autism.org.uk/get-involved/donate/cash-appeal/its-how-you-show-up-appeal';
        });

        /*
         * Watch the real pledge modal for display/class changes.
         * This also handles the modal being replaced by AJAX.
         */
        const containsPledgeModal = node => {
            if (!(node instanceof Element)) {
                return false;
            }

            return (
                node.id === 'dw_pledge_modal' ||
                node.querySelector('#dw_pledge_modal') !== null
            );
        };

        const modalObserver = new MutationObserver(mutations => {
            const modalChanged = mutations.some(mutation => {
                if (
                    mutation.type === 'attributes' &&
                    mutation.target instanceof Element &&
                    mutation.target.id === 'dw_pledge_modal'
                ) {
                    return true;
                }

                if (mutation.type === 'childList') {
                    return Array
                        .from(mutation.addedNodes)
                        .some(containsPledgeModal);
                }

                return false;
            });

            if (!modalChanged) {
                return;
            }

            ensurePledgeModalAtBodyLevel();

            requestVisibilityUpdate();
        });

        modalObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'style',
                'class',
                'aria-hidden'
            ]
        });

        window.addEventListener(
            'scroll',
            requestVisibilityUpdate,
            { passive: true }
        );

        window.addEventListener('resize', requestVisibilityUpdate);

        updateVisibility();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }

})();
